






































































import Vue from "vue";
import heic2any from "heic2any";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { SET_DARK_BACKGROUND } from "@/constants/mutation-types";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "File",
  props: {
    name: String,
    headerFile: String,
  },
  data() {
    return {
      isUploadError: false as boolean,
      size: null as null | number,
      isCleared: false,
      isDragged: false,
      isFilled: false as boolean | string,
      isHEIF: false,
      dragAndDropSupported: false as boolean,
      file: null as any,
      fileExtensions: ["jpg", "jpeg", "png", "gif", "HEIC", "HEIF", "avif", "pdf"] as string[],
      imageString: null as string | ArrayBuffer | null,
      TRANSLATION_KEY: "basic.fields.File",
    };
  },
  mounted(): void {
    const div = document.createElement("div");
    this.dragAndDropSupported = "draggable" in div || ("ondragstart" in div && "ondrop" in div);
  },
  methods: {
    handlePopup(): void {
      this.$store.state.isPhotoInstructionsOpen = !this.$store.state.isPhotoInstructionsOpen
    },

    checkFileUploaded(evt: MouseEvent): void {
      const label = this.$refs.label as HTMLElement;

      if (label.classList.contains("green-btn")) {
        evt.preventDefault();
      }
    },

    dropEvent(evt: DragEvent): void {
      this.dragLeaveService(evt);

      const dataTransfer = evt.dataTransfer as DataTransfer;

      if (dataTransfer) {
        const draggedFile = dataTransfer.files[0];
        const splitArray = dataTransfer.files[0].name.split(".");
        const fileExtension = splitArray[splitArray.length - 1];

        const isConsistentExtension = this.fileExtensions.filter(
          (ext: string) => ext.toLowerCase() === fileExtension.toLowerCase()
        );

        if (isConsistentExtension.length) {
          if (isConsistentExtension.includes("HEIF") || isConsistentExtension.includes("HEIC")) {
            this.isHEIF = true;

            this.convertImage(draggedFile)
              .then((result) => (this.file = result))
              .then((image: any) => this.readImageAsString(image));
          } else {
            this.file = this.validatePhotoExtension(draggedFile);
            this.readImageAsString(this.file);
          }
        } else {
          this.$emit("fileTypeValidation");
        }
      }
    },

    clearImage() {
      this.isFilled = false;
      this.isUploadError = false;
      this.isHEIF = false;
      this.imageString = null;
      this.file = null;
      this.size = null;
      (this.$refs.input as HTMLFormElement).value = null;
    },

    updateFile(): void {
      const inputFile = this.$refs.input as HTMLFormElement;
      const uploadedFiles = inputFile.files;

      if (uploadedFiles && uploadedFiles[0]) {
        const uploadedFile = uploadedFiles[0];
        const splitArray = uploadedFile.name.split(".");
        const fileExtension = splitArray[splitArray.length - 1];

        const isConsistentExtension = this.fileExtensions.filter(
          (ext: string) => ext.toLowerCase() === fileExtension.toLowerCase()
        );

        if (isConsistentExtension.length) {
          if (isConsistentExtension.includes("HEIF") || isConsistentExtension.includes("HEIC")) {
            this.isHEIF = true;

            this.convertImage(uploadedFile)
              .then((result) => (this.file = result))
              .then((image: any) => this.readImageAsString(image));
          } else {
            this.file = this.validatePhotoExtension(uploadedFile);
            this.readImageAsString(this.file);
          }
        } else {
            this.$emit("fileTypeValidation", true);
        }
      }

    },

    validatePhotoExtension(file: File) {
      const splittedFileName = file.name.split(".");
      const ext = splittedFileName[splittedFileName.length - 1].toLowerCase();

      if (ext !== "jpeg") {
        return file;
      } else {
        const blob = new Blob([file], { type: "image/jpeg" });
        // get file name without extension
        let fileName: any = file.name.split(".");
        fileName = fileName.slice(0, fileName.length - 1).join(".");
        // create new File with good extension
        return new File([blob], `${fileName}.jpg`, { type: "image/jpeg" });
      }
    },

    dragEnterService(evt: DragEvent): void {
      this.preventDefault(evt);
      this.isDragged = true;
    },

    dragLeaveService(evt: DragEvent): void {
      this.preventDefault(evt);
      this.isDragged = false;
    },

    readImageAsString(image: File): void {
      const reader = new FileReader();
      const t = this;

      reader.readAsDataURL(image);
      reader.addEventListener("load", function () {
        t.addThumbNail(this.result);
      });
    },

    addThumbNail(result: string | ArrayBuffer | null): void {
      this.imageString = result;
      this.isFilled = true;
      this.$store.state.isLocked = ''
      this.$store.state.errors.delete('documentImage')
      setTimeout(() => {
        this.$store.state.isLoaderText = false
      }, 200);
},

    preventDefault(evt: DragEvent): void {
      evt.preventDefault();
    },

    setCompressedImage(blob: Blob, mimeType: string): void {
      this.file = new File([blob], this.file.name, { type: mimeType });
    },

    async compressImage(x: number, y: number, callback: CallableFunction): Promise<any> {
      let sizeMB: number | null = null;

      if (this.file) {
        const getFileSize = (this.file.size / 1024 / 1024).toFixed(2);
        sizeMB = (getFileSize as any) / 1;

        this.size = sizeMB;
      }

      if (sizeMB! >= 7.0) {
        const canvas = document.createElement("canvas");

        canvas.width = x;
        canvas.height = y;

        const ctx = canvas.getContext("2d");

        await UtilityHelper.sleep(1000);
        const imageElement =
          document.querySelector(".normal-picture-element") || document.querySelector(".heic-picture-element");

        const splittedArr = this.file.name.split(".");
        const extension = splittedArr[splittedArr.length - 1];
        const mimeType = extension.toLowerCase() === "jpg" ? "image/jpeg" : `image/${extension.toLowerCase()}`;

        ctx!.drawImage(imageElement as HTMLImageElement, 0, 0, x, y);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              callback(blob, mimeType);
            }
          },
          mimeType,
          1
        );
      }
    },

    async convertImage(uploadedFile: File) {
      const convertedFile = await heic2any({
        blob: uploadedFile,
        toType: "image/jpeg",
        quality: 0.5,
      });

      let filename: any = uploadedFile.name.split(".");
      filename = filename.slice(0, filename.length - 1).join(".");

      return new File([convertedFile], filename + ".jpg", {
        type: "image/jpeg",
      });
    },
  },
  watch: {
    async imageString() {
      if (this.size! >= 7.0) {
        await UtilityHelper.sleep(2750);
      }

      this.$emit("update", {
        key: this.name,
        value: this.file,
      });
    },

    file() {
      this.compressImage(1280, 1024, this.setCompressedImage);
    },

    errors() {
      if (this.errors.size) {
        this.isUploadError = true;
        this.$emit("seterror", this.isUploadError);
        this.clearImage();
      }
    },
  },
  computed: {
    ...mapGetters(["errors"]),
    ...mapState({
      isDetectedMobileDevice: (state: any) => state.isDetectedMobileDevice,
      hasError: (state: any) => state.errors
    }),
  },
});
